<template>
  <b-row>
    <b-col lg="3" md="3" sm="12" order="1">
      <b-card class="sticky-card">
        <h5 class="kb-title">
          <b-icon icon="info-circle" class="mr-1" />
          Covered Topics
        </h5>
        <vue-perfect-scrollbar :settings="scrollSettings" class="scroll-style">
          <ul class="mt-1">
            <li
              v-for="(topic, index) in relatedTopics"
              :key="index"
              class="ml-n2"
            >
              <b-link :href="`#${topic.href}`" class="list-item">{{
                topic.name
              }}</b-link>
            </li>
          </ul>
        </vue-perfect-scrollbar>
      </b-card>
    </b-col>
    <b-col lg="9" md="9" sm="12" order="2">
      <b-card>
        <h1 class="mb-1" align="center">Security Dashboard</h1>
        <div class="question-content">
          <SecurityGuideContent></SecurityGuideContent>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

import SecurityGuideContent from '@/xvisor/views/knowledgeBase/components/SecurityGuideContent.vue';

export default {
  components: {
    SecurityGuideContent,
    VuePerfectScrollbar,
  },
  data() {
    return {
      scrollSettings: {
        maxScrollbarLength: 50,
      },
      relatedTopics: [
        { name: 'Overview', href: '1-overview' },
        { name: 'Network Analytics Tab', href: '2-network-analytics-tab' },
        { name: 'Service Tabs', href: '2-1-service-tabs' },
        { name: 'Select a Tab to Focus on a Service', href: '2-1-1-select-a-service-tab' },
        { name: 'Data View Controls', href: '2-1-2-data-view-controls' },
        { name: 'Detailed Data View', href: '2-1-3-detailed-data-view' },
        { name: 'Traffic Details for an IP Address', href: '2-1-4-traffic-details' },
        { name: 'Select a data point for more details', href: '2-1-5-data-point-details' },
        { name: 'IDS Logs Tab', href: '2-2-ids-logs-tab' },
        { name: 'Threats Tab', href: '2-3-threats-tab' },
        { name: 'Endpoint Analytics Tab', href: '3-endpoint-analytics-tab' },
        { name: 'Packages Tab', href: '3-1-packages-tab' },
        { name: 'Processes Tab', href: '3-2-processes-tab' },
        { name: 'Devices Tab', href: '3-3-devices-tab' },
        { name: 'Users Tab', href: '3-4-users-tab' },
        { name: 'Traffic Tab', href: '3-5-traffic-tab' },
        { name: 'Alerts Tab', href: '3-6-alerts-tab' },
      ],
    };
  },
};
</script>
